

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// getAllTiers
// GETALLTIERS
const GETALLTIERS= createAsyncThunk(
  "getAllTiers/getAllTiers",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getAllTiersSlice = createSlice({
  name: "getAllTiersSlice",
  initialState: {
    getAllTiers: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetAllTiers: (state) => {
        state.getAllTiers.loading = false
        state.getAllTiers.error = false
        state.getAllTiers.data = []
        state.getAllTiers.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETALLTIERS.fulfilled, (state, action) => {
      state.getAllTiers = {
        ...state.getAllTiers,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLTIERS.pending, (state, action) => {
      state.getAllTiers = {
        ...state.getAllTiers,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLTIERS.rejected, (state, action) => {
      state.getAllTiers = {
        ...state.getAllTiers,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getAllTiersAction = {
    GETALLTIERS,
};

export { getAllTiersAction };
export default getAllTiersSlice.reducer;
export const {setInitialStateOfgetAllTiers} = getAllTiersSlice.actions
